module.exports = __webpack_public_path__ + "static/media/Logos for Animation and Drone Page.0ca9189f.png";